import { PaperType } from '../types/paper.types';

/**
 * Following preset is from Venngage editor 1
 */
const PageSizePreset = {
  [PaperType.LETTER]: {
    widthPx: 816,
    heightPx: 1056,
    widthIn: 8.5,
    heightIn: 11,
    widthCm: 21.59,
    heightCm: 27.94,
  },
  [PaperType.LEGAL]: {
    widthPx: 816,
    heightPx: 1344,
    widthIn: 8.5,
    heightIn: 14,
    widthCm: 21.59,
    heightCm: 35.56,
  },
  [PaperType.TABLOID]: {
    widthPx: 1056,
    heightPx: 1632,
    widthIn: 11,
    heightIn: 17,
    widthCm: 27.94,
    heightCm: 43.18,
  },
  [PaperType.A3]: {
    widthPx: 1122,
    heightPx: 1588,
    widthIn: 11.69,
    heightIn: 16.54,
    widthCm: 29.69,
    heightCm: 42.02,
  },
  [PaperType.A4]: {
    widthPx: 794,
    heightPx: 1122,
    widthIn: 8.27,
    heightIn: 11.69,
    widthCm: 21.01,
    heightCm: 29.69,
  },
  [PaperType.A5]: {
    widthPx: 560,
    heightPx: 794,
    widthIn: 5.83,
    heightIn: 8.27,
    widthCm: 14.82,
    heightCm: 21.01,
  },
  [PaperType.PRESENTATION]: {
    widthPx: 1024,
    heightPx: 576,
    widthIn: 10.67,
    heightIn: 6,
    widthCm: 27.09,
    heightCm: 15.24,
  },
  [PaperType.INSTAGRAM]: {
    widthPx: 1080,
    heightPx: 1080,
    widthIn: 11.25,
    heightIn: 11.25,
    widthCm: 28.58,
    heightCm: 28.58,
  },
  [PaperType.FACEBOOK]: {
    widthPx: 1200,
    heightPx: 630,
    widthIn: 12.5,
    heightIn: 6.54,
    widthCm: 31.75,
    heightCm: 16.62,
  },
  [PaperType.LINKEDIN]: {
    widthPx: 1200,
    heightPx: 628,
    widthIn: 12.5,
    heightIn: 6.56,
    widthCm: 31.75,
    heightCm: 17.18,
  },
  [PaperType.TWITTER]: {
    widthPx: 1024,
    heightPx: 512,
    widthIn: 10.67,
    heightIn: 5.33,
    widthCm: 27.09,
    heightCm: 13.55,
  },
  [PaperType.PINTEREST]: {
    widthPx: 735,
    heightPx: 1102,
    widthIn: 7.66,
    heightIn: 11.48,
    widthCm: 19.45,
    heightCm: 29.17,
  },
};

export { PageSizePreset };
